import { create } from 'zustand';

type NeedType = 'rent' | 'food' | 'shelter' | 'legal' | 'jobs';

interface NeedState {
  selectedNeed: NeedType;
  setSelectedNeed: (need: NeedType) => void;
}

export const useNeedStore = create<NeedState>((set) => ({
  selectedNeed: 'rent',
  setSelectedNeed: (need) => set({ selectedNeed: need }),
}));